<template>
    <!--@formatter:off-->
    <div class="wrap">
        <div class="bx_back" @click="$router.back()">
            <a class="btn_back">{{$t('common_previousPage')}}</a>
        </div>

        <div class="bx_round_white card_news">
            <div class="bx_card_news detail type2">
                {{$t(payload.message)}}
            </div>
        </div>
    </div>
    <!--@formatter:on-->
</template>

<script>
export default {
    name: "SimpleErrorMessage",

    props: {
        payload: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped>

</style>